const template = require('./selectList.template');
require('./selectList.style');

interface ListItem {
	value:string;
	detail?:string;
	selected?:boolean;
}

interface InternalListItem<T> extends ListItem{
	filtered:boolean;
	source:T;
}

class SelectList<T> implements ng.IComponentController {
	public static $inject = [
		'gettextCatalog',
		'$mdMedia'
	];

	public transform:(source:T) => ListItem;
	public items:InternalListItem<T>[];
	public filterPhrase:string = '';
	public selectedAll:boolean = false;
	public get filtered(){
		return this.items.filter(i => i.filtered);
	}
	public get selected(){
		return this.items.filter(i => i.selected);
	}
	public filterLabel:string = angular.isDefined(this.filterLabel) ? 
		this.filterLabel : 
		this.gettextCatalog.getString('Filter');

	private source:T[];
	private onSelect:(args:Object) => void;
	private selectionLimit:number;
	
	constructor(
		private gettextCatalog:ng.gettext.gettextCatalog,
		private $mdMedia:any
	){
	}

	public $onChanges(changes:ng.IOnChangesObject){
		if(changes.source && this.source){
			this.items = [];
			this.items = this.source.map(sourceItem => {
				let item = this.transform(sourceItem) as InternalListItem<T>;
				item.selected = angular.isDefined(item.selected) ? item.selected : false;
				item.filtered = false;
				item.source = sourceItem;
				return item;
			});
		}
	}

	public selectItem(item:InternalListItem<T>){
		if (this.selectionLimit && this.selected.length >= this.selectionLimit) {
			item.selected = false;
		}
		else {
			item.selected = !item.selected;
			this.emitSelected();
		}
	}

	public filter(){
		let phrase = this.filterPhrase.toLowerCase();
		this.items.forEach(i => {
			i.filtered = i.value.toLowerCase().search(phrase) < 0 &&
				i.detail.toLowerCase().search(phrase) < 0;
		});
	}
	
	public clearFilter(){
		this.filterPhrase = '';
		this.filter();
	}
	public toggleSelectAll(){
		this.selectedAll = !this.selectedAll;
		if(this.selectedAll){
			this.selectAll();
		}
		else {
			this.clearAll();
		}
	}

	public clearAll(){
		this.items.forEach(i => i.selected = false);
		this.emitSelected();
	}

	public selectAll(){
		this.items.forEach(i => i.selected = true);
		this.emitSelected();
	}

	private emitSelected(){		
		this.onSelect({
			selected: this.selected.map(item => item.source)
		});
	}
}

export const SelectListComponent:ng.IComponentOptions = {
	controllerAs: 'vm',
	template,
	controller: SelectList,
	bindings: {
		source: '<',
		transform: '<',
		filterLabel: '@?',
		onSelect: '&',
		selectionLimit: '<?'
	}
};


// WEBPACK FOOTER //
// ./src/sharebase/components/selectList/selectList.ts